import { Injectable } from '@angular/core';
import {BaseService} from '../base.service';
import {environment} from '../../../../environments/environment';
import {AnketaResult} from '../../../pages/anketa/interfaces/anketa.interface';
import {HttpHeaders} from '@angular/common/http';
import {Region} from '../../store/region/region.interface';

@Injectable({
  providedIn: 'root',
})
export class AnketaService extends  BaseService{

  public createAnketa(body:AnketaResult){
    return this.http.post(`${environment.baseUrl}/service/webapi/v1/surveys`, body)
  }
}
